/**
 * Reorders a column by moving draggedColumnId to the position of targetColumnId
 * Does NOT mutate the original array
 */
export const reorderColumn = (columnOrder: string[], draggedColumnId: string, targetColumnId: string): string[] => {
  const newOrder = [...columnOrder]
  newOrder.splice(newOrder.indexOf(targetColumnId), 0, newOrder.splice(newOrder.indexOf(draggedColumnId), 1)[0]!)
  return newOrder
}

/**
 * Moves a column to the end of the array (second-to-last position before last item)
 * Used when toggling column visibility
 * Does NOT mutate the original array
 */
export const moveColumnToEnd = (columnOrder: string[], columnId: string): string[] => {
  const newOrder = [...columnOrder]
  const index = newOrder.indexOf(columnId)
  // TRK-4827: if column isn't in the order array, append it instead of corrupting
  // the array (splice(-1,1) would remove the last element).
  if (index === -1) return [...newOrder, columnId]
  newOrder.splice(newOrder.length > 0 ? newOrder.length - 1 : 0, 0, newOrder.splice(index, 1)[0]!)
  return newOrder
}
